import {
  NodesEditorActionTypes,
  NodesEditorActions,
} from './nodes-editor-modal.actions';
import {
  NODES_EDITOR_MODAL_INITIAL_STATE,
  NodesEditorModalState,
} from './nodes-editor.state';

export function nodeEditorModalReducer(
  state: NodesEditorModalState = NODES_EDITOR_MODAL_INITIAL_STATE,
  action: NodesEditorActions,
): NodesEditorModalState {
  switch (action.type) {
    case NodesEditorActionTypes.NODES_EDITOR_SHOW_MODAL: {
      const { listId, isDraft } = action.payload;
      return {
        ...state,
        isModalShown: true,
        hierarchyEditor: {
          listId,
          isDraft,
          hierarchyAndStudentNumbers: null,
          isLoading: false,
          isSaving: false,
          loadingError: null,
          savingError: null,
        },
      };
    }

    case NodesEditorActionTypes.NODES_EDITOR_HIDE_MODAL: {
      return { ...state, isModalShown: false, hierarchyEditor: null };
    }

    case NodesEditorActionTypes.NODES_EDITOR_NODES_REQUESTED: {
      const { listId, isDraft } = action.payload;
      return {
        ...state,
        hierarchyEditor: {
          hierarchyAndStudentNumbers: null,
          isLoading: true,
          isSaving: false,
          listId,
          isDraft,
          loadingError: null,
          savingError: null,
        },
      };
    }

    case NodesEditorActionTypes.NODES_EDITOR_NODES_LOADED: {
      const { listId, isDraft, hierarchyAndStudentNumbers } = action.payload;
      return {
        ...state,
        hierarchyEditor: {
          hierarchyAndStudentNumbers,
          isLoading: false,
          isSaving: false,
          listId,
          isDraft,
          loadingError: null,
          savingError: null,
        },
      };
    }

    case NodesEditorActionTypes.NODES_EDITOR_NODES_LOADING_FAILED: {
      const { listId, isDraft, error } = action.payload;
      return {
        ...state,
        hierarchyEditor: {
          hierarchyAndStudentNumbers: null,
          isLoading: false,
          isSaving: false,
          listId,
          isDraft,
          loadingError: error,
          savingError: null,
        },
      };
    }

    case NodesEditorActionTypes.NODES_EDITOR_SAVE_NODES: {
      const { hierarchyAndStudentNumbers } = action.payload;
      return {
        ...state,
        hierarchyEditor: {
          ...state.hierarchyEditor,
          hierarchyAndStudentNumbers,
          isSaving: true,
          savingError: null,
        },
      };
    }

    case NodesEditorActionTypes.NODES_EDITOR_SAVE_NODES_FAILED: {
      const { error } = action.payload;
      return {
        ...state,
        hierarchyEditor: {
          ...state.hierarchyEditor,
          isSaving: false,
          savingError: error,
        },
      };
    }

    case NodesEditorActionTypes.NODES_EDITOR_SAVE_NODES_SUCCEEDED: {
      return {
        ...state,
        hierarchyEditor: {
          ...state.hierarchyEditor,
          isSaving: false,
          savingError: null,
        },
      };
    }

    case NodesEditorActionTypes.NODES_EDITOR_NEW_LIST_PERSIST_NODES: {
      return {
        ...state,
        hierarchyEditor: {
          ...state.hierarchyEditor,
          hierarchyAndStudentNumbers: action.payload,
        },
      };
    }

    case NodesEditorActionTypes.NODES_EDITOR_NEW_LIST_HIDE_MODAL: {
      return { ...state, isModalShown: false };
    }

    case NodesEditorActionTypes.NODES_EDITOR_NEW_LIST_SHOW_MODAL: {
      return {
        ...state,
        isModalShown: true,
      };
    }

    default: {
      return state;
    }
  }
}
